import { Injectable, Injector, ProviderToken, inject } from '@angular/core';
import { LstAuthService, LstUserService } from '@savvaslearning/lst-auth';
import { filter, take } from 'rxjs/operators';

import { HeartbeatService } from './heartbeat.service';
import { SessionExpiryService } from './session-expiry.service';

@Injectable({ providedIn: 'root' })
export class SessionTimeoutService {
  private readonly injector = inject(Injector);
  private readonly heartbeat = inject(HeartbeatService);
  private readonly expiry = inject(SessionExpiryService);
  private started = false;

  start(): void {
    if (this.started) return;
    const userService = this.resolve(LstUserService);
    if (!userService) return;
    this.started = true;
    userService.rbsToken$
      .pipe(
        filter((token) => !!token),
        take(1),
      )
      .subscribe((token: string) => {
        this.heartbeat.start(userService.getCurrentUserId(), token);
        this.watchForSessionExpiry();
      });
  }

  private watchForSessionExpiry(): void {
    const authService = this.resolve(LstAuthService);
    if (!authService) return;
    authService
      .onBeforeExpiry()
      .pipe(take(1))
      .subscribe(() => {
        this.heartbeat.destroy();
        this.expiry.notifyExpired();
      });
  }

  private resolve<T>(token: ProviderToken<T>): T | null {
    try {
      return this.injector.get(token, null);
    } catch {
      return null;
    }
  }
}
